import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { NegocioModel } from './Negocio.model';
import { ParamNegociosId } from './Negocio.model';
import { DefCiudades } from './Negocio.model';
import { DefContribuyentes } from './Negocio.model';
import { DefCiudadesId } from './Negocio.model';
import { OpcionModel } from '../Global/Opcion.model';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';

import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';
import { MatSnackBar } from '@angular/material';



@Component({
	selector : 'negocio',
	templateUrl : './NegocioEdit.component.html'
})

/**
* @author Camilo
* @since  26/10/2017
**/
export class NegocioEditComponent {
	
	// ~~~~~ Variables para el manejo de permisos ~~~~~ //
	public btnAgregar:boolean;
	public btnEditar:boolean;
	public btnEliminar:boolean;
	public btnConsultar:boolean;
	// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //

	public form: FormGroup;
	public  formErrors: any;
	public ocultar: boolean = false;
	

	
	public negocio:NegocioModel;

	public departamentos:Array<OpcionModel> = new Array();
	public ciudades:Array<OpcionModel> = new Array();
	public tiposContribuyentes:Array<OpcionModel> = new Array();
	public negocios:Array<NegocioModel> = new Array();

	public emisores:Array<OpcionModel> = new Array();

	public tiposCobro:Array<OpcionModel> = new Array();

	public guardando:boolean;

	public contrato:string = '';

	public bloquearLLave:boolean = false;


	public cantidadPrefijos:number = 0;
	public cantidadUsuarios:number = 0;
	public cantidadMandantes:number = 0;



	public labelCampo:string = "";
	public bloquearValor:boolean = true;


	public tipoEmpresa:string = "";

	public mensaje: string = "";

	constructor(private formBuilder: FormBuilder, private _serviciosGenerales:ServiciosGenerales, public snackBar: MatSnackBar, 
		private _route: ActivatedRoute, private _router:Router)
	{

		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.btnAgregar = _serviciosGenerales.seguridad.isAgregar();
		this.btnEditar = _serviciosGenerales.seguridad.isEditar();
		this.btnEliminar = _serviciosGenerales.seguridad.isEliminar();
		this.btnConsultar = _serviciosGenerales.seguridad.isConsultar();
		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.snackBar.dismiss();
		this.formErrors = {

			idNegocio : {},
			nombre : {},
			nit : {},
			digito:{},
			dfechacreacion:{},
			direccion:{},
			idDepartamento:{},
			idCiudad:{},
			telefono : {},
			correo:{},
			tipoContribuyente : {},
			tipoCobro : {},
			regimen : {},
			idContable : {},
			valor:{},
			emisor: {},
			jefeAdmon: {}

		};

		this.departamentos = new Array();
		this.ciudades = new Array();
		this.negocios = new Array();
		this.tiposContribuyentes = new Array();
		this.tiposCobro = new Array();
		this.emisores = new Array();

		this.negocio = new NegocioModel(new ParamNegociosId('', 0), '', '', 0,  new Date(),'', new DefCiudades(new DefCiudadesId(0, '','169')), '', '',new DefContribuyentes('') , '', '', 0, 0, '', 0, '',0,0, '');
		this.guardando = false;

		

		var x = this._serviciosGenerales.seguridad.getInfoToken();
		this.tipoEmpresa = JSON.parse(x.ntipoempresa).ntipoempresa+ ' - '+JSON.parse(x.tipoempresa).tipoempresa;

		//console.log("----> ",this.tipoEmpresa);

	}

	ngOnInit()
	{
				
		this._route.params.subscribe( params =>{
			console.log('------------------------->', params['id'].split(' ').join(''), ' -- ',params, ' ------------ ',(!!params['id']));	
			
			
			if(!!params['id'] == true){
				this.contrato = params['id'];
				this.bloquearLLave = true;
			}else{
				this.contrato = '';
			}

			// ~~~~~~ Se carga la info básica ~~~~~~~ //
			this.cargarInfo();

			if(!!params['id']){
				this.cargarNegocio();
			}else{
				console.log('Antes : ',this.negocio);
				//this._serviciosGenerales.getParametros('NEGOCIOS', this.negocio);
				console.log('Despues : ',this.negocio);
				
			}
			this.inicializarForm();
		this.form.valueChanges.subscribe(() => {
				this.onFormValuesChanged();
		});	
		});
	}

	private inicializarForm(){
		console.log('->> ',this.bloquearLLave);
		this.form = this.formBuilder.group({
			digito   : [
			{
				value   : "0",
				disabled: true
			}, Validators.required
			],
			dfechacreacion : ['', Validators.required],
			idnegocio : [
			{
				value : (this.bloquearLLave == true ? this.negocio.id.cnumcont : ''),
				disabled: this.bloquearLLave
			}, Validators.required
			],
			nombre : ['', Validators.required],
			nit : [{
					value   : "",
					disabled: true
				}, Validators.required],
			direccion : ['', Validators.required],
			idDepartamento : [{value : ''}, Validators.required],
			idCiudad : ['', Validators.required],
			telefono : [Validators.compose([Validators.required, Validators.minLength(7), Validators.maxLength(10), Validators.pattern("[0-9]+")])],
			correo : ['', Validators.required],
			jefeAdmon: ['', Validators.required],
			tipoContribuyente : [{
					value   : ""
				}, Validators.required],
			tipoCobro : ['', Validators.required],
			regimen : ['', Validators.required],
			idContable : ['', Validators.required],
			emisor : ['', Validators.required],
			valor : [
			{
				value   : this.negocio.nvalor,
				disabled: this.bloquearValor
			}, Validators.required
			]
		});
		
	}

	onFormValuesChanged()
	{
		for ( const field in this.formErrors )
		{

			if ( !this.formErrors.hasOwnProperty(field) )
			{
				continue;
			}

			// Clear previous errors
			this.formErrors[field] = {};

			// Get the control
			const control = this.form.get(field);

			if ( control && control.dirty && !control.valid )
			{
				this.formErrors[field] = control.errors;
			}
		}
	}


	private cargarInfo(){

		if (JSON.parse(this._serviciosGenerales.seguridad.getInfoToken().ntipoempresa).ntipoempresa == 1){
			this.negocio.vcorreo = 'jlvelez1234@bancolombia.com.co'
		}

		
		this._serviciosGenerales.get('departamentos', {param:0}).subscribe(
			result =>{
				for(let x of result){
					this.departamentos.push(new OpcionModel(x.ccodigodepto.trim(), x.vnombre.trim()));
					
				}
					
			}, 
			error =>{
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar los tipos departamentos", "X");
			});

		
		this._serviciosGenerales.get('tiposContribuyente', {param:0}).subscribe(

			result =>{
				for(let x of result)
					this.tiposContribuyentes.push(new OpcionModel(x.nidcontribuyente, x.vdescripcion));
			}, 
			error =>{
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar los tipos de contribuyente", "X");
			});

		this._serviciosGenerales.get('tipoCobro', {param:0}).subscribe(

			result =>{
				for(let x of result)
					this.tiposCobro.push(new OpcionModel(x.ntipo, x.cdescipcion));
			}, 
			error =>{
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar los tipos de contribuyente", "X");
			});


		this._serviciosGenerales.get('conteoPrefijoNegocio', {cnumcont:this.contrato.trim()}).subscribe(

			result =>{
				this.cantidadPrefijos = result[0].conteo
			}, 
			error =>{
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar la cantidad de prefijos", "X");
			});


		this._serviciosGenerales.get('cantidadUsuariosNegocio', {cnumcont:this.contrato.trim()}).subscribe(

			result =>{
				this.cantidadUsuarios = result[0].conteo
			}, 
			error =>{
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar la cantidad de usuarios", "X");
			});
			
			console.log("va a consultar mandantes");

		

		this._serviciosGenerales.get('consultarEmisores', {param:0}).subscribe(

			result =>{
				for(let x of result)
					this.emisores.push(new OpcionModel(x.ccodemi, x.nombre));
			}, 
			error =>{
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar los tipos de contribuyente", "X");
			});
		
		
	}

	public validarNegocio() : boolean{
		this._serviciosGenerales.get('validarNegocio', {cnumcont:this.negocio.id.cnumcont.trim(), cnit : this.negocio.cnit}).subscribe(

			result =>{
				if(result[0].c > 0){
					this.openSnackBarEspecial('El contrato: '+this.negocio.id.cnumcont.trim()+' ya existe en el sistema', 'X');
					return false;
				}else{
					return true;
				}
				
			}, 
			error =>{
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar la cantidad de usuarios", "X");
				return false;
			});
		return false;
	}




	private cargarNegocio(){
		//console.log('Contrato que envía : ',this.contrato);
		this._serviciosGenerales.get('detalleNegocio', {cnumcont:this.contrato}).subscribe(
			result =>{
				let x = result[0];

				console.log("----------------------------> ",x.dfechacreacion);

				let contribuyente = new DefContribuyentes('');
				contribuyente.nidcontribuyente = x.nidcontribuyente
				this.negocio = new NegocioModel(new ParamNegociosId(x.cnumcont, x.ntipoempresa), x.vnombrenegocio, x.cnit, x.nidcheck,new Date(x.dfechacreacion), x.vdireccion, new DefCiudades(new DefCiudadesId(x.ccodigociudad, x.ccodigodepto,"169")), 
					x.ntelefono, x.vcorreo,contribuyente ,x.vregimen ,x.ccodcontab.trim(), 0, 0, x.ntipo, x.nvalor, x.ccodemi,x.ntiponegocio,x.nactaterminacion,x.vjefeadmon);
				console.log(this.negocio);
				this.consultarCiudades('-1');
				this.validarCampo(false);
			}, 
			error =>{
				var errorMensaje = <any>error;

				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar los negocios", "X");
			});
		
	}


	public validarCampo(x){
		//console.log(this.form.get('valor').value, ' .. ',this.form.get('valor'));
		if(this.form.get('valor').value == '' && x == true){
			this.form.get('valor').setValue(0);
			this.negocio.nvalor = 0;
		}

		if(this.negocio.ntipo == '3'){
			this.bloquearValor = false;
			this.labelCampo = "Tope";
			this.form.get('valor').enable();
			
		}else if(this.negocio.ntipo == '4'){
			this.bloquearValor = false;
			this.labelCampo = "Porcentaje especial";
			this.form.get('valor').enable();
			
		}else{
			this.bloquearValor = true;
			this.labelCampo = "";
			this.form.get('valor').disable();
			this.form.get('valor').setValue(0);
		}
		
		

	}

	public cargarInformacionEmisor(x){
		//console.log(x);
		this._serviciosGenerales.get('consultarInformacionEmisor', {ccodemi : x}).subscribe(x =>{
			//console.log('TERMINA DE CONSULTAR ',x);
			x = x[0];
			this.negocio.cnit = x.CNUMID.trim();
			this.negocio.vdireccion = x.VDIRECCION.trim();
			this.negocio.nidcheck = x.NIDCHECK;
			//console.log(this.departamentos, ' <------> ', x);
			this.negocio.defCiudades.id.ccodigodepto = x.CDEPARTAMENTO;
			this.calcularDV(this.negocio.cnit);
			setTimeout(() => {
				console.log("ASIGNA CIUDAD : ", x.CCIUDAD, ' ----- ', this.ciudades);
				//this.negocio.defCiudades.id.ccodigociudad = ;
				this.consultarCiudades(x.CCIUDAD);
				this.negocio.vcorreo = x.VCORREO.trim();
				this.negocio.defContribuyentes.nidcontribuyente = x.CTIPOREGIMEN;
				this.negocio.ntelefono = x.CTELEFONO;	
			}, 500);
			
		}, error => {
			this.openSnackBarEspecial("Ocurrió un error mientras se carga la información del emisor", "X");
		})
	}


	openSnackBar(message: string, action: string)
	{
		this.snackBar.open(message, action, {
			duration: 20000
		});
	}


	consultarCiudades(id:string){
		this.ciudades = new Array();
		this._serviciosGenerales.get('ciudades', {ccodigodepto:this.negocio.defCiudades.id.ccodigodepto}).subscribe(
			result =>{
				
				for(let x of result)
					this.ciudades.push(new OpcionModel(x.ccodigociudad, x.vnombre.trim()));
				if(parseInt(id) > -1){
					this.negocio.defCiudades.id.ccodigociudad = parseInt(id);
				}
			}, 
			error =>{
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar las ciudades", "X");
			}
			);
	}

	calcularDV(nit) {
		var arreglo, x, y, z, i, nit1, dv1;
		if (isNaN(+nit)) {
			this.openSnackBarEspecial('Número del Nit no valido, ingrese un número sin puntos, ni comas, ni guiones, ni espacios','X');
		} else {
			arreglo = new Array(16);
			x = 0;
			y = 0;
			z = nit.length;
			console.log("LENGHTTTTTTTTT"+z)
			arreglo[1] = 3;
			arreglo[2] = 7;
			arreglo[3] = 13;
			arreglo[4] = 17;
			arreglo[5] = 19;
			arreglo[6] = 23;
			arreglo[7] = 29;
			arreglo[8] = 37;
			arreglo[9] = 41;
			arreglo[10] = 43;
			arreglo[11] = 47;
			arreglo[12] = 53;
			arreglo[13] = 59;
			arreglo[14] = 67;
			arreglo[15] = 71;
			for (i = 0; z > i; i++) {
				y = (nit.substr(i, 1));				
				x += (y * arreglo[z - i]);
			}
			y = x % 11;
			if (y > 1) {
				dv1 = 11 - y;
			} else {
				dv1 = y;
			}
			//this.negocio.nidcheck = dv1;

		}

	}


	consultar(negocio:NegocioModel){
		//console.log(negocio, ' -- ');
		this.negocio = negocio;
		this.consultarCiudades( this.negocio.defCiudades.id.ccodigociudad.toString() );
	}

	guardar(){	
		var cadena = this.negocio.vcorreo.split(";");
		for (var i=0; i < cadena.length; i++) {
		      if(!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(cadena[i].trim()))){
			    this.openSnackBarEspecial('El correo electronico'+cadena[i].trim()+' no cumple con una estructura correcta', 'X');
				return;  	
		      }
	   	}


		if(this.form.valid == false){
			this.openSnackBarEspecial('Hay Campos requeridos sin llenar', 'X');
			return;
		}

		var isnum = /^\d+$/.test(this.negocio.ccodcontab);

		if(isnum == false){
			this.openSnackBarEspecial("El Id Contable debe ser un número", "X");
			return;
		}
		if(new Number(this.negocio.ccodcontab) < 0 || new Number(this.negocio.ccodcontab) == -0){
			this.openSnackBarEspecial("El Id Contable no puede ser menor a cero", "X");
			return;
		}

		if(this.negocio.ntipo == '4' && (this.negocio.nvalor > 100 || this.negocio.nvalor < 0) ) {
			this.openSnackBarEspecial("El Porcentaje especial debe estar en un rango de 0 a 100", "X");
			return;
		}
		this.ocultar = true;
		this._serviciosGenerales.get('validarNegocio', {cnumcont:this.negocio.id.cnumcont.trim(), cnit : this.negocio.cnit}).subscribe(

			result =>{
				if(result[0].c > 0 && this.bloquearLLave == false){
					this.openSnackBarEspecial('El contrato: '+this.negocio.id.cnumcont.trim()+' ya existe en el sistema', 'X');
					
				}else{
					this.guardarSinValidacion();
				}
				
			}, 
			error =>{
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar la cantidad de usuarios", "X");
				
			});
		
	}
	bloquearBoton(){
		var count = 1;
		this.guardar()
	}


	

	guardarSinValidacion(){

		this.guardando = true;
		this.negocio.ntiponegocio = (this.negocio.ntiponegocio == true ? 1 : 0);
		this.negocio.nactaterminacion = (this.negocio.nactaterminacion == true ? 1 : 0);
		if(this.negocio.nactaterminacion == null || this.negocio.nactaterminacion == undefined){
			this.negocio.nactaterminacion = 0;
		}

		if(String(this.negocio.defContribuyentes.nidcontribuyente).trim() == ''){
			this.negocio.defContribuyentes.nidcontribuyente = '8';	
		}
		
		this.negocio.defCiudades.id.ccodigopais="169";
		this._serviciosGenerales.post('negocio', this.negocio).subscribe(
			result =>{
				if(this.bloquearLLave == false){
					let MchUsuCont = {id : {cusuario : this._serviciosGenerales.seguridad.getInfoSesion().usuario.trim().toUpperCase(), cnumcont : this.negocio.id.cnumcont} }
					this._serviciosGenerales.post('guardar/usucont', MchUsuCont).subscribe(
						result =>{

							this.openSnackBar("Proceso realizado con éxito", "X");
							this.guardando = false;
							this._router.navigate(['/Negocio']);

						},
						error =>{
							var errorMensaje = <any>error;
							console.log('Error al enviar la peticion ', errorMensaje);
							this.openSnackBarEspecial("Ocurrió un error al momento de guardar el usuario del negocio", "X");
						})
				}else{
					this.openSnackBar("Proceso realizado con éxito", "X");
					this.guardando = false;
					this._router.navigate(['/Negocio']);
				}
			}, 
			error =>{
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de guardar el negocio", "X");
			}
			);
	}

	addEvent(type: string, event: MatDatepickerInputEvent<Date>) {
		
	}

	openSnackBarEspecial(message: string, action: string) {
		let snackBarRef =  this.snackBar.open(message, action);

		snackBarRef.onAction().subscribe(() => {
			console.log("Paso por aqui 1 notas");

			this.ocultar = false;
			this.mensaje = "";
		});
		
		let shand = document.getElementsByClassName('mat-snack-bar-container') as HTMLCollectionOf<HTMLElement>;		
		
		if (shand.length != 0) {
			    for (let i=0;i<shand.length;i++){
				shand[i].style.backgroundColor = "rgb(255 204 214)";
				}
			}
	}

}





// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/Negocio/NegocioEdit.component.ts